import { refresh_instance } from '@/utils/refresh_http.js'

// 刷新token  
export const refresh_token = function (data) {
  return refresh_instance({
    url: '/api/v1/refresh_token',
    method: 'post',
    data
  })
}